import { Grid2 as Grid, Typography } from "@mui/material";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { IO_FOR_PRODUCT_EXECUTION_TIMELINE } from "constants/taskConstants";
import { pageName } from "constants/pageNames";
import { useEffect, useState } from "react";
import { getInputOutputForProductExecutionTimelineApi } from "API/apis/product/getInputOutputForProductExecutionTimeline";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import { InputOutputViewerComponent } from "../components/InputOutputViewerComponent";

export const InputOutputForExecutionTimeline = () => {
  const { id } = useParams();
  const { setError, setIsInitializing, setIsLoading } = useGlobalContext();

  const [data, setData] = useState();
  const fetchInputOutput = async (id) => {
    try {
      setIsInitializing(true);
      const { data, status } =
        await getInputOutputForProductExecutionTimelineApi(Number(id));
      if (status !== 200) {
        throw new Error(data.message);
      }
      setData(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsInitializing(false);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchInputOutput(id);
  }, [id]);
  return (
    <>
      <FlexBox justifyContent="space-between">
        <Typography variant="h5" sx={{ mb: 2 }}>
          {pageName.product.inputOutputModal}
        </Typography>
      </FlexBox>
      <FlexBox justifyContent="space-between">
        <Grid container spacing={2}>
          <Grid container xs={12} md={4}>
            {Object.keys(IO_FOR_PRODUCT_EXECUTION_TIMELINE).map(
              (item, index) => {
                if (item !== "Buffer") {
                  return (
                    <InputOutputViewerComponent
                      key={index}
                      row={data}
                      partLotId={id}
                      title={item}
                      availableInputItems={
                        IO_FOR_PRODUCT_EXECUTION_TIMELINE[item].inputItems
                      }
                      availableOutputItems={
                        IO_FOR_PRODUCT_EXECUTION_TIMELINE[item].outputItems
                      }
                      inputData={data?.[item]?.input}
                      outputData={data?.[item]?.output}
                      reFetchInputOutput={fetchInputOutput}
                    />
                  );
                }
              }
            )}
          </Grid>
        </Grid>
      </FlexBox>
    </>
  );
};
